module.exports = __webpack_public_path__ + "img/sp.1eea68ff.png";